export default "__VITE_PUBLIC_ASSET__26448541__"